import { typography } from 'assets/styles'
import styled, { css } from 'styled-components'

export const Wrapper = styled.li<{ isNavbarWhite?: boolean }>`
    margin-left: 20px;
    display: flex;
    align-items: center;
    max-height: 60px;
    cursor: pointer;
    padding: 12px;

    &:hover {
        background-color: ${({ theme }) =>
            theme.states.interaction.primary.hover.value};

        ${({ theme, isNavbarWhite }) =>
            isNavbarWhite &&
            css`
                background-color: ${theme.colors.interaction.alternative};
            `}
    }
`

export const Greeting = styled.div`
    ${typography.ButtonMedium16};
    color: ${(props) => props.theme.colors.monochrome.white};
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const DropdownWrapper = styled.div`
    ${typography.BodyCopy16};
    line-height: 16px;
    color: ${(props) => props.theme.colors.monochrome.white};
    display: flex;
    align-items: center;
    flex-direction: row;
    outline: 2px solid transparent;
    outline-offset: 2px;
    border-radius: 0px;

    span {
        margin-right: 6px;
    }
`

export const UserInfo = styled.div<{ isNavbarWhite?: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 10px;
    position: relative;

    ${({ isNavbarWhite, theme }) =>
        isNavbarWhite &&
        css`
            ${Greeting} {
                color: ${theme.colors.monochrome.ravenSub};
            }

            ${DropdownWrapper} {
                color: ${theme.colors.monochrome.ravenSub};
            }
        `}
`
